import React, { useCallback, useState } from 'react';
import type { EmblaCarouselType } from 'embla-carousel';

import type { TSmeCarousel } from '../models';

interface IUseArrowsProps
    extends Pick<TSmeCarousel, 'arrowsView' | 'Arrow' | 'FullHeightArrow' | 'fullMode'> {
    emblaApi?: EmblaCarouselType;
    setAutoplay: (value: boolean) => void;
}

export const useArrows = ({
    Arrow,
    FullHeightArrow,
    arrowsView,
    emblaApi,
    fullMode,
    setAutoplay,
}: IUseArrowsProps) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

    const scrollPrev = useCallback(() => {
        emblaApi?.scrollPrev();
        setAutoplay(false);
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        emblaApi?.scrollNext();
        setAutoplay(false);
    }, [emblaApi]);

    let arrows;

    if (arrowsView === 'arrowInCircle') {
        arrows = (
            <>
                {!prevBtnDisabled && (
                    <Arrow direction="left" onClick={scrollPrev} shadow={!fullMode} />
                )}
                {!nextBtnDisabled && (
                    <Arrow direction="right" onClick={scrollNext} shadow={!fullMode} />
                )}
            </>
        );
    }

    if (arrowsView === 'fullHeight') {
        arrows = (
            <>
                <FullHeightArrow
                    btnDisabled={prevBtnDisabled}
                    direction="left"
                    onClick={scrollPrev}
                />
                <FullHeightArrow
                    btnDisabled={nextBtnDisabled}
                    direction="right"
                    onClick={scrollNext}
                />
            </>
        );
    }

    return { setPrevBtnDisabled, setNextBtnDisabled, arrows };
};
